// @flow
import HtmlVideoStreamer from '../components/player/VideoStreamer/HtmlVideoStreamer/HtmlVideoStreamer';
export default HtmlVideoStreamer;
